import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Label = styled.label`
  margin: 0;
`;

const LabelText = styled.div`
  color: ${p => p.theme.colors.lightFont};
  font-size: 1.125rem;
  font-weight: 500;
  line-height: 1.39;
  letter-spacing: 0.2px;
  margin-bottom: 10px;
`;

const Required = styled.span`
  color: ${p => p.theme.colors.alert};
`;

const Field = styled.textarea`
  border-width: 1px;
  border-style: solid;
  border-color: ${p =>
    p.hasError
      ? p.theme.colors.error
      : p.isValid
        ? p.theme.colors.valid
        : p.theme.colors.border};
  line-height: 1.5;
  margin: 0;
  padding: 10px;
  width: 100%;
  min-width: 100%;
`;

const ErrorMessage = styled.div`
  color: ${p => p.theme.colors.error};
  font-size: 0.875rem;
  margin-top: 5px;
`;

export default function Textarea({
  label,
  value,
  placeholder,
  isRequired,
  error,
  touched,
  onChange,
  onBlur,
  ...rest
}) {
  return (
    <Label>
      <LabelText>
        <LabelText>
          {label} {isRequired && <Required>*</Required>}
        </LabelText>
      </LabelText>

      <Field
        {...rest}
        rows="8"
        required={false} //@todo: actiavte (isRequired)
        placeholder={placeholder}
        value={value}
        hasError={touched && error}
        isValid={touched && !error}
        onChange={onChange}
        onBlur={onBlur}
      />

      {touched && error && <ErrorMessage>{error}</ErrorMessage>}
    </Label>
  );
}

Textarea.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  isRequired: PropTypes.bool,
  error: PropTypes.string,
  touched: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func
};

Textarea.defaultProps = {
  value: '',
  placeholder: '',
  isRequired: false,
  error: '',
  touched: false,
  onChange: () => {},
  onBlur: () => {}
};
